// extracted by mini-css-extract-plugin
export default {"loading":"mLIUXGZT9U2vUj2OUVr3-style-loading","productCardWrapper":"d7IJwV5MhWjGHu7_vfcz-style-productCardWrapper"};